import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  DateField,
  NumberField,
  FunctionField,
  useTheme,
  RecordContextProvider,
  ChipField,
} from "react-admin";
import accountReceivablePaymentFilterList from "../../components/accountReceivablePayments/filter/accountReceivablePaymentFilterList";
import AccountReceivablePaymentExpandList from "../../components/accountReceivablePayments/expand/AccountReceivablePaymentExpandList";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import AccountReceivablePaymentFooterList from "../../components/accountReceivablePayments/footer/AccountReceivablePaymentFooterList";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";
import ManualReportList from "../../components/reports/ManualReportList";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const AccountReceivablePaymentList = () => {
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
    });
  const [theme] = useTheme("light");

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.list_title.account_receivable_payment"
        empty={false}
        actions={<DownloadAction />}
        filters={accountReceivablePaymentFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={
            <MyDatagridBody footer={<AccountReceivablePaymentFooterList />} />
          }
          // FIXME: semua datagrid perlu pake custom bulk action ini
          bulkActionButtons={false}
          expand={<AccountReceivablePaymentExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.depo" />
          ) : null}
          <TextField source="code" label="mine.label.receipt_no" />
          <DateField
            source="date"
            label="mine.label.date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <TextField source="customer.code" label="mine.label.customer_code" />
          <TextField source="customer.name" label="mine.label.customer" />
          <TextField source="tbp" />
          <FunctionField
            textAlign="center"
            label="mine.label.type"
            render={(record) => {
              let rec = {};
              switch (record.type) {
                case 1:
                  rec.type = "Transfer";
                  rec.color = "success";
                  break;
                case 2:
                  rec.type = "Cash";
                  rec.color = "primary";
                  break;
                case 3:
                  rec.type = "Giro";
                  rec.color = "warning";
                  break;
                default:
                  rec.type = "-";
                  rec.color = "default";
              }
              return (
                <RecordContextProvider value={rec}>
                  <ChipField source="type" color={rec.color} size="small" />
                </RecordContextProvider>
              );
            }}
          />
          <NumberField source="total" />
          <TextField source="note" label="mine.label.note" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return <>{list}</>;
};

export default AccountReceivablePaymentList;
